import {useMutation, useQueryClient} from '@tanstack/react-query';

import {resolveVideo, ResolveVideoParams} from '../api';
import {QUERY__VIDEOS} from '../queryKeys';

export const useResolveVideo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: ResolveVideoParams) => resolveVideo(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__VIDEOS],
      });
    },
  });
};
